import React from 'react'
import {connect} from 'react-redux'

import {
  VIEWPORT_TYPES
} from '../shared/config/constants'

class UnreadMessageIndicator extends React.Component {
  render () {
    if (this.props.viewportType !== VIEWPORT_TYPES.PHONE) return false
    if (!this.props.shouldShowIt) return false

    return <div className='unread-message-indicator'>!</div>
  }
}

const mapStateToProps = (state) => {
  return {
    shouldShowIt: state.get('shouldShowNewMessageIndicatorOnMobile'),
    viewportType: state.getIn(['viewport', 'type'])
  }
}

const UnreadMessageIndicatorContainer = connect(
  mapStateToProps
)(UnreadMessageIndicator)

export default UnreadMessageIndicatorContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/unread_message_indicator.js
 **/